module.exports = __webpack_public_path__ + "static/img/honour7.23ee06e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/honour7.png
// module id = ktCm
// module chunks = 1